import type { ReactNode } from "react";
import { Reveal } from "@/components/reveal";

export function Section({
  children,
  className = "",
  tone = "light",
  id,
}: {
  children: ReactNode;
  className?: string;
  tone?: "light" | "night" | "mist";
  id?: string;
}) {
  const toneClass =
    tone === "night" ? "night" : tone === "mist" ? "bg-[var(--mist)]" : "bg-background";
  return (
    <section id={id} className={`relative ${toneClass} py-20 md:py-28 ${className}`}>
      <div className="shell">{children}</div>
    </section>
  );
}

export function SectionTitle({
  eyebrow,
  title,
  lead,
  light = false,
}: {
  eyebrow: string;
  title: ReactNode;
  lead?: string;
  light?: boolean;
}) {
  return (
    <Reveal className="max-w-2xl">
      <p className={light ? "eyebrow-light" : "eyebrow"}>{eyebrow}</p>
      <h2 className="display mt-4 text-4xl sm:text-5xl lg:text-[3.4rem]">{title}</h2>
      {lead ? (
        <p className="mt-5 text-[15px] leading-relaxed text-muted-foreground">{lead}</p>
      ) : null}
    </Reveal>
  );
}
